/**
 * FV（商品画像）スライダー制御（クリック特化・安定版）
 * - 依存なし
 * - SP：ネイティブ横ドラッグ（scroll）を邪魔しない（触らない）
 * - PC：矢印クリック & 左右半分クリックで前後移動
 * - ドット：スクロール位置に追従
 *
 * 前提DOM:
 *  [data-isk-fv-slider] (root)
 *    .product-images-scrollable.isk-fv-slider  (scroller)  ← 横スクロール担当
 *      .js-isk-fv-gallery                      (gallery)   ← 子要素がスライド
 *    .js-isk-fv-prev / .js-isk-fv-next / .js-isk-fv-dots
 */
(() => {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const initOne = (root) => {
    const gallery = root.querySelector('.js-isk-fv-gallery');
    if (!gallery) return;

    const scroller =
  (root.matches('.product-images-scrollable.isk-fv-slider') ? root : null)
  || root.querySelector('.product-images-scrollable.isk-fv-slider')
  || gallery;

    const slides = Array.from(gallery.children).filter((el) => el.nodeType === 1);
    if (slides.length <= 1) return;

    if (root.dataset.iskFvInited === '1') return;
    root.dataset.iskFvInited = '1';

    const prev = root.querySelector('.js-isk-fv-prev');
    const next = root.querySelector('.js-isk-fv-next');
    const dotsWrap = root.querySelector('.js-isk-fv-dots');

    let lastScrollAt = 0;

    const getIndexFromScroll = () => {
      const w = scroller.clientWidth || 1;
      return clamp(Math.round(scroller.scrollLeft / w), 0, slides.length - 1);
    };

    const scrollToIndex = (index, behavior = 'smooth') => {
  const i = clamp(index, 0, slides.length - 1);
  const left = i * scroller.clientWidth;
  try {
    scroller.scrollTo({ left, behavior });
  } catch {
    scroller.scrollLeft = left;
  }
};

    // ----- dots -----
    const dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'isk-fv-dot';
        b.setAttribute('aria-label', `画像 ${i + 1} / ${slides.length}`);
        b.addEventListener('click', () => scrollToIndex(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    let activeIndex = getIndexFromScroll();
    const setActive = (i) => {
      activeIndex = i;
      if (dots.length) {
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      }
    };
    setActive(activeIndex);

    // ----- arrows -----
    if (prev) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        const i = getIndexFromScroll();
        scrollToIndex((i - 1 + slides.length) % slides.length);
      });
    }
    if (next) {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        const i = getIndexFromScroll();
        scrollToIndex((i + 1) % slides.length);
      });
    }

    // ----- click: 左右半分クリックで前後移動（PC向け） -----
    // 「別JSが stopPropagation しても拾えるように capture=true」で付ける（重要）
    const isInteractive = (el) =>
      !!el.closest(
        'button, a, input, label, summary, details, .js-isk-fv-prev, .js-isk-fv-next, .js-isk-fv-dots'
      );

    scroller.addEventListener('click', (e) => {
  if (isInteractive(e.target)) return;
  if (Date.now() - lastScrollAt < 250) return;

  const rect = scroller.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const i = getIndexFromScroll();
  if (x >= rect.width / 2) {
    scrollToIndex((i + 1) % slides.length);
  } else {
    scrollToIndex((i - 1 + slides.length) % slides.length);
  }
  // ズーム発火を抑止
  e.stopPropagation();
  e.preventDefault();
}, true);  // ← capture: true

    // ----- sync dots with scroll -----
    let ticking = false;
    scroller.addEventListener(
      'scroll',
      () => {
        lastScrollAt = Date.now();

        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const i = getIndexFromScroll();
          if (i !== activeIndex) setActive(i);
        });
      },
      { passive: true }
    );

    // ----- keep alignment on resize -----
    window.addEventListener('resize', () => {
      const i = getIndexFromScroll();
      scrollToIndex(i, 'auto');
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-isk-fv-slider]').forEach(initOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify テーマエディタでの section 再読み込み対策（あっても害なし）
  document.addEventListener('shopify:section:load', initAll);
})();
